export const msalConfig = {
    auth: {
        clientId: "d4d414f9-62a2-4b32-b2bb-41f54560410b",
        authority: "https://login.microsoftonline.com/6ffe9835-ce5a-4d0e-b29a-1557a4de59aa",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["User.Read", "Mail.Send", "Mail.Send.Shared"],
};
